import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getTransaction = async (id) => {
    const { data: transactionId, error: transactionError } = await supabase
        .from('transactions')
        .select('*, user_shippings(*, user_profiles(*))')
        .eq('id', id)
        .in('status', ['Paid', 'Refund In Progress'])
        .maybeSingle();

    if (transactionError) {
        throw new Error(`Error fetching transaction: ${transactionError.message}`);
    }


    return transactionId;
};


export default function useGetTransactionById(id) {
    return useQuery({
        queryKey: ['useGetTransactionById', id],
        queryFn: () => getTransaction(id),
        staleTime: 0,
        enabled: !!id
    })
}
